import { rankings } from "@/mocks/home";

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-label tracking-wide text-accent-700">
              <i className="ri-fire-line" />
              热度榜
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              本月最受关注的章节
            </h2>
          </div>
          <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs font-label text-foreground-600">
            <i className="ri-refresh-line" />
            数据更新于今日 08:00
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.6fr_1fr] lg:gap-8">
          <ol className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {rankings.map((r, i) => (
              <li
                key={r.title}
                className={`flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5 ${
                  i !== rankings.length - 1 ? "border-b border-background-200" : ""
                }`}
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-black ${
                    r.rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {r.rank}
                </span>
                <div className="h-12 w-9 shrink-0 overflow-hidden rounded border border-background-200">
                  <img
                    src={r.cover}
                    alt={`${r.title}章节封面`}
                    title={`善良的女秘书 ${r.title}`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-heading text-sm font-bold text-foreground-950">
                    {r.title}
                  </p>
                  <p className="mt-0.5 truncate text-xs font-label text-foreground-500">{r.meta}</p>
                </div>
                <span
                  className={`hidden shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs font-label sm:inline-flex ${
                    r.rank <= 3
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className="ri-arrow-up-line" />
                  {r.heat}
                </span>
              </li>
            ))}
          </ol>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-secondary-800 bg-secondary-950 p-5">
              <span className="flex items-center gap-2 text-xs font-label tracking-wide text-accent-400">
                <i className="ri-rocket-2-line" />
                本周飙升
              </span>
              <p className="mt-3 font-heading text-lg font-bold text-background-50">
                《加班到很晚》
              </p>
              <p className="mt-2 text-sm leading-6 text-background-300">
                有声版上线后阅读量一周内增长 18%，是本周涨幅最高的一章。
              </p>
              <button
                type="button"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-xs font-label text-background-50 transition-colors hover:bg-accent-600"
              >
                去读这一章
                <i className="ri-arrow-right-line" />
              </button>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-sm font-bold text-foreground-950">榜单说明</h3>
              <ul className="mt-3 space-y-2 text-xs leading-6 text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                  综合阅读量、收听量与收藏数计算。
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                  每小时更新一次，排序可能实时变化。
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                  榜单仅统计已发布章节，不含预览内容。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}